import {
  PiHouseLineDuotone,
  PiArrowsInDuotone,
  PiBookOpenUserDuotone,
  PiBookBookmarkDuotone,
  PiAcornDuotone,
  PiBagSimpleDuotone,
  PiCalendar,
  PiCashRegister,
  PiPackageDuotone,
  PiFolders,
  PiDatabase,
} from "react-icons/pi";
import type { JSX } from "react";

import {
  MdAnalytics,
  MdDesignServices,
  MdLocalActivity,
  MdOutlineGrid3X3,
  MdSubscriptions,
} from "react-icons/md";
import { BsPeople } from "react-icons/bs";
import { GiSatelliteCommunication } from "react-icons/gi";
import { FiSettings } from "react-icons/fi";
import { HiSupport } from "react-icons/hi";
import { SiI18Next } from "react-icons/si";

export type NavigationIcons = Record<string, JSX.Element>;

const navigationIcon: NavigationIcons = {

  CpI18n: <SiI18Next />,
  CpCstlnData: <PiDatabase />,

  home: <PiHouseLineDuotone />,
  calendar: <PiCalendar />,
  priceplans: <PiCashRegister />,
  support: <HiSupport />,
  product_registration: <HiSupport />,
  subscriptions: <MdSubscriptions />,
  activities: <MdLocalActivity />,
  statistics: <MdAnalytics />,
  customers: <BsPeople />,
  assets: <MdOutlineGrid3X3 />,
  look_and_feel: <MdDesignServices />,
  folders: <PiFolders />,

  products: <PiPackageDuotone />,
  communication: <GiSatelliteCommunication />,

  settings: <FiSettings />,

  singleMenu: <PiAcornDuotone />,
  collapseMenu: <PiArrowsInDuotone />,
  groupSingleMenu: <PiBookOpenUserDuotone />,
  groupCollapseMenu: <PiBookBookmarkDuotone />,
  groupMenu: <PiBagSimpleDuotone />,
};

export default navigationIcon;
